import { getTags } from 'application/repositories/tagsRepository';
import logger from 'helpers/logger';
import useSWR from 'swr';

const getTagsFromRepository = async (rootId: number): Promise<Tags.Tag[]> => {
	return await getTags({ rootId });
};

export interface TagsFetcherResult {
	tags?: Tags.Tag[];
	isLoading: boolean;
}

export const TagsFetcher = (rootId: number): TagsFetcherResult => {
	const { data, error } = useSWR([rootId], getTagsFromRepository, {
		revalidateOnFocus: false,
	});
	if (error) {
		logger.error(`TagsFetcher.ts failed: ${error}`, error);
		throw error;
	}

	if (!data) return { isLoading: true };
	return { tags: data, isLoading: false };
};
